import React, { useEffect, useState } from 'react';
import UserService from '../../services/api/user-service';
import { rootContainer, TYPE } from '../../services/container/root';
import './iframe-page.scss';

interface IframePageProps {
    url: string;
}

const IframePage: React.FC<IframePageProps> = ({ url }) => {
    // Identity request explanation
    // When the session is invalidated on the server but still exists in the browser,
    // the iframe request can receive an unauthorized response while the top-level client still renders the dashboard shell.
    // In that case, rendering the iframe would show the login page inside the header/sidebar layout.
    // To avoid this, we already have a check in http client to redirect to the login page if the response is unauthorized.
    // So this iframe will be never loaded

    const [isIdentityLoaded, setIsIdentityLoaded] = useState(false);

    useEffect(() => {
        const loadIdentity = async () => {
            try {
                const userService = rootContainer.get<UserService>(TYPE.UserService);
                await userService.getCurrentPortalIdentity();
                setIsIdentityLoaded(true);
            } catch (e) {
                console.error('[IframePage::loadIdentity] failed:', e);
            }
        };

        loadIdentity();
    }, []);

    if (!isIdentityLoaded) {
        return null;
    }

    return (
        <div className="iframe-page">
            <div className="iframe-page-content">
                <iframe
                    src={url}
                    className="iframe-page-iframe"
                    title="Store Front Localization"
                />
            </div>
        </div>
    );
};

export default IframePage;
